import { AirplaneIcon, BuildingsIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import PageError from "@/components/Errors/PageError";

interface OfferNotAvailableErrorProps {
  variant: "flight" | "hotel";
}

export const OfferNotAvailableError = ({
  variant,
}: OfferNotAvailableErrorProps) => {
  const intl = useIntl();
  const Icon = variant === "flight" ? AirplaneIcon : BuildingsIcon;

  return (
    <PageError
      title={intl.formatMessage({
        id:
          variant === "flight"
            ? "flights.notAvailable.title"
            : "hotels.notAvailable.title",
      })}
      subtitles={[
        intl.formatMessage({
          id:
            variant === "flight"
              ? "flights.notAvailable.description"
              : "hotels.notAvailable.description",
        }),
      ]}
      back={{
        text: intl.formatMessage({
          id:
            variant === "flight"
              ? "flights.notAvailable.button"
              : "hotels.notAvailable.button",
        }),
        options: {
          to: variant === "flight" ? "/flights/departure/list" : "/hotels/list",
        },
      }}
      icon={<Icon size={60} color="var(--color-text-interactive)" />}
    />
  );
};
